export enum Region {
    NA = 'North and Latin America',
    EU = 'Europe, Middle East, and North Africa',
    FE = 'Asia Pacific',
}